import React, { useState } from 'react'
import history from 'pages/history'
import { Container, Row, Button, Col, Card, Form, Spinner } from 'react-bootstrap'
import { ArrowBackOutlined, BusinessOutlined } from '@material-ui/icons'
import { FormImputNumber } from 'components/Form'
import ResalesRequestService from 'services/resales-request'
import Alert from 'helpers/alert'
import Swal from 'sweetalert2'

export default function () {
  const [isSaving, setIsSaving] = useState()
  const [name, setName] = useState("")
  const [alias, setAlias] = useState("")
  const [document, setDocument] = useState("")
  const [address, setAddress] = useState("")
  const [addressNumber, setAddressNumber] = useState("")
  const [addressComplement, setAddressComplement] = useState("")
  const [addressNeighborhood, setAddressNeighborhood] = useState("")
  const [addressState, setAddressState] = useState("")
  const [addressCity, setAddressCity] = useState("")
  const [addressZipcode, setAddressZipcode]   = useState("")
  const [category, setCategory] = useState(null)

  function fetchCepData(cep) {
    fetch(`https://viacep.com.br/ws/${cep}/json/`)
      .then(res => res.json())
      .then(res => {
        setAddress(res.logradouro)
        setAddressNeighborhood(res.bairro)
        setAddressState(res.uf)
        setAddressCity(res.localidade)
      })
  }

  function handleSubmit() {
    setIsSaving(true)
    var formData = new FormData()
    formData.append('name', name)
    formData.append('alias', alias)
    formData.append('document', document)
    formData.append('address', address)
    formData.append('address_number', addressNumber)
    formData.append('address_complement', addressComplement)
    formData.append('address_neighborhood', addressNeighborhood)
    formData.append('address_state', addressState)
    formData.append('address_city', addressCity)
    formData.append('address_zipcode', addressZipcode)
    formData.append('ma_category', category)
    formData.append('is_masteragent', 1)
    formData.append('cfy[company_type_id]', 2)
    //formData.append('cfy[headquarter]', 1)
    formData.append('cfy[is_masteragent]', 1)
    //formData.append('cfy[is_premium]', 0)

    ResalesRequestService.store(formData)
      .then(() => {
        Alert.success("Empresa cadastrada com sucesso").then((result) => {
          if (result.dismiss === Swal.DismissReason.timer) {
            history.goBack()
          }
        });        
      })
      .finally(() => setIsSaving(false))
  }

  return (
    <Container>
      <Row className="mt-4">
        <Button variant="link"
          onClick={() => history.goBack()}
        >
          <ArrowBackOutlined /> Voltar
        </Button>
      </Row>
      <Row className="col-12 row">
        <BusinessOutlined className="icon-title" />
        <h5 className="title-dashboard">Cadastrar Empresa</h5>
      </Row>
      <Row className="col-12">
        <Card.Body className="card-dashboard shadow bg-white rounded p-1 p-5 col-12">
          <Form>
            <Row className="mt-0">
              <Col md="12">
                <h6 className="title-dashboard">Dados da Empresa</h6>
              </Col>
              <Col md="12">
                <hr className="line"></hr>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <Form.Group>
                  <Form.Label>Razão Social</Form.Label>
                  <Form.Control 
                    as="input"
                    value={name}
                    onChange={e => setName(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group>
                  <Form.Label>Nome Fantasia</Form.Label>
                  <Form.Control 
                    as="input"
                    value={alias}
                    onChange={e => setAlias(e.target.value)}                    
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group>
                  <Form.Label>CNPJ</Form.Label>
                  <FormImputNumber 
                    as="input"
                    value={document}
                    mask="{2}.{3}.{3}/{4}-{2}"
                    onChange={cnpj => setDocument(cnpj)}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group>
                  <Form.Label>Categoria</Form.Label>
                  <Form.Control
                    as="select"
                    value={category}
                    onChange={e => {
                      setCategory(e.target.value)
                    }}
                  >
                    <option selected disabled>Selecione</option>
                    <option value="1">Ouro - Comissão 250%</option>
                    <option value="2">Prata - Comissão 200%</option>
                  </Form.Control>
                </Form.Group>
              </Col>     
            </Row>
            <Row className="">
              <Col md="12">
                <h6 className="title-dashboard">Endereço</h6>
              </Col>
              <Col md="12">
                <hr className="line"></hr>
              </Col>
            </Row>
            <Row>
              <Col md="3">
                <Form.Group>
                  <Form.Label>CEP:</Form.Label>
                  <FormImputNumber 
                    value={addressZipcode}
                    onChange={cep => {
                      setAddressZipcode(cep)
                      if (cep.length == 8) 
                        fetchCepData(cep)
                    }}
                    mask="{5}-{3}"
                  />
                </Form.Group>
              </Col>
              <Col md="7">
                <Form.Group>
                  <Form.Label>Endereço</Form.Label>
                  <Form.Control
                    disabled
                    as="input"
                    value={address}
                    onChange={e => setAddress(e.target.value)}                    
                  />
                </Form.Group>
              </Col>
              <Col md="2">
                <Form.Group>
                  <Form.Label>Nª</Form.Label>
                  <Form.Control
                    as="input"
                    value={addressNumber}
                    onChange={e => setAddressNumber(e.target.value)}                    
                  />
                </Form.Group>
              </Col>
              <Col md="3">
                <Form.Group>
                  <Form.Label>Estado</Form.Label>
                  <Form.Control
                    disabled
                    as="input"
                    value={addressState}
                    onChange={e => setAddressState(e.target.value)}                    
                  />
                </Form.Group>
              </Col>
              <Col md="3">
                <Form.Group>
                  <Form.Label>Cidade</Form.Label>
                  <Form.Control
                    disabled
                    as="input"
                    value={addressCity}
                    onChange={e => setAddressCity(e.target.value)}                    
                  />
                </Form.Group>
              </Col>
              <Col md="3">
                <Form.Group>
                  <Form.Label>Bairro</Form.Label>
                  <Form.Control
                    disabled
                    as="input"
                    value={addressNeighborhood}
                    onChange={e => setAddressNeighborhood(e.target.value)}                    
                  />
                </Form.Group>
              </Col>
              <Col md="3">
                <Form.Group>
                  <Form.Label>Complemento</Form.Label>
                  <Form.Control
                    as="input"
                    value={addressComplement}
                    onChange={e => setAddressComplement(e.target.value)}                    
                  />
                </Form.Group>
              </Col>           
            </Row>
            <Button 
              className="mt-5" 
              onClick={() => handleSubmit()}
            >
              Salvar {isSaving ? <Spinner animation="border" role="status" size="sm" /> : (<></>)}
            </Button>
          </Form>
        </Card.Body>
      </Row>
    </Container>
  )
}